import { TagRoom, TagFurnitureType, TagFurnitureUse } from './tags';

const PLACEHOLDER_PREVIEW_URL = 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/716530e6-34ea-4061-9889-ac80569f43bc.png';
const PLACEHOLDER_MODEL_URL = 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e83fe56b-f48e-42a6-ab8c-89d79dd63578.dae';

export const models = {
  'hgdesign-umbrella-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/3a6162f2-6b0e-4de0-abdb-f38dc50a2d7e.png',
    modelUrl: 'https://cdn.wtlstudio.com/sample.wtlstudio.com/6ced31e6-d95a-4a21-8efc-56c5999d1d53.glb',
    modelScale: 10.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Terrace Umbrella',
      owner: 'HOOGSTRATEN DESIGN',
      designer: 'HOOGSTRATEN DESIGN',
      priceBase: 29900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 192, 120 ],
      ],
      materialNames: [
        'White/eggshell',
        'White/charcoal',
      ],
      sizeOptions: [
        [ 1.0, 1.0 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagRoom.livingRoom,
        TagFurnitureUse.relax
      ]
    }
  },
  'hgdesign-sofa-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/3225f139-8479-4732-a2da-915474beb92f.png',
    modelUrl: 'https://cdn.wtlstudio.com/sample.wtlstudio.com/978e5e85-6e5e-443a-8f90-f08ec69def12.glb',
    modelScale: 1.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Terrace Cabana',
      owner: 'HOOGSTRATEN DESIGN',
      designer: 'HOOGSTRATEN DESIGN',
      priceBase: 59900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 192, 120 ],
      ],
      materialNames: [
        'White',
        'Black',
        'Red',
      ],
      sizeOptions: [
        [ 1.0, 1.0 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.relax,
        TagFurnitureUse.seat,
        TagFurnitureType.bed,
        TagFurnitureType.sofa
      ]
    }
  },
  'ikea-stuva-wardrobe-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/7f308cbc-da20-4936-b9d1-1fe2a7086ad4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a9e0c979-2004-4b66-bc16-98dfdbab31e2.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STUVA Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 28900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 192, 120 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/light pink',
        'White/red'
      ],
      sizeOptions: [
        [ .5, 1.2 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-pink',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-sundvik-wardrobe-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/65f8b5a5-ea63-4062-a39f-042fe4002118.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1241a52d-35ed-4ee7-a2b1-c87df92d8773.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'SUNDVIK Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 15900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 80, 171, 50 ],
      ],
      materialNames: [
        'Grey-brown'
      ],
      sizeOptions: [
        [ .5, .8 ],
      ],
      materialOptions: [
        'ikea-sundvik-wardrobe'
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-stuva-wardrobe-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/f102c027-0bb5-4ef9-83aa-aeba3ecd9676.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/05c87e25-5b22-4c2a-a3f9-34d71fbc9fc6.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STUVA ½ Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 16500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 192, 60 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/light pink',
        'White/red'
      ],
      sizeOptions: [
        [ .5, .6 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-pink',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-godishus-chest-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/1ecb4fcf-08a7-45d1-87a0-1acd8565ac37.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5cd59d4e-86ba-453a-8155-f5571ffba1d6.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'GODISHUS 3-Drawer Chest',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 64, 60 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/red'
      ],
      sizeOptions: [
        [ .5, .6 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-stuva-wardrobe-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/4d35e101-8a51-49aa-b662-5a5ffc14771c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/27483c1a-b246-4327-9a35-85f1d3cfe755.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STUVA 6-Drawer Chest',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 13500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 128, 60 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/light pink',
        'White/red'
      ],
      sizeOptions: [
        [ .5, .6 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-pink',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-busunge-wardrobe-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/b9fc1b52-9991-4bc8-8672-81f062f115b6.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3affcc44-2b63-468b-8ac9-e4296b1672b4.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BUSUNGE Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 9995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 139, 80 ],
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .5, .8 ],
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-stuva-wardrobe-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a3ebf752-fbdc-4116-bb93-59804a476f8e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/cc2266ae-7d3d-49f8-8e7e-84a01bde6f26.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STUVA Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 12800,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 50, 192, 60 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/light pink',
        'White/red'
      ],
      sizeOptions: [
        [ .5, .6 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-pink',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-trofast-frame-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a2eb04f0-5f67-4e9e-9493-bf7e66f420d4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9ae6ca17-9e10-4685-bd35-b8ded69c9d60.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TROFAST Frame (small)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 44, 56, 99 ],
      ],
      materialNames: [
        'White/white',
        'White/blackboard surface',
        'White/light blue',
        'White/light pink',
        'White/red'
      ],
      sizeOptions: [
        [ .44, .99 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'ikea-white-blue',
        'ikea-white-pink',
        'ikea-white-red'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-trofast-frame-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a2eb04f0-5f67-4e9e-9493-bf7e66f420d4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9ae6ca17-9e10-4685-bd35-b8ded69c9d60.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TROFAST Frame (small)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 44, 56, 99 ],
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .44, .99 ],
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-trofast-frame-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8888ba47-4ffa-4f46-877f-bca2dac866db.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d9cbce65-8c52-4851-8a44-9473a873721b.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TROFAST Frame',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3895,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 44, 94, 99 ],
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .44, .99 ],
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ]
    }
  },
  'ikea-poang-chair-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/be018987-0d29-4358-94ac-2c3a751704e7.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5a988065-8b20-435a-b34f-37ae2300f2bf.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'POÄNG Armchair',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 47, 68, 56 ],
      ],
      materialNames: [
        'Birch veneer/almås beige',
      ],
      sizeOptions: [
        [ .47, .56 ],
      ],
      materialOptions: [
        'ikea-poang-beige',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.seat,
        TagFurnitureUse.relax,
      ]
    }
  },
  'ikea-loberget-chair-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/1ca949a2-007d-488e-ac7c-afc1872d8b0a.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/10c170b6-80f4-456c-985f-bf4db1ece72a.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LOBERGET Desk chair',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 56, 49, 56 ],
      ],
      materialNames: [
        'White',
        'White/black seat',
      ],
      sizeOptions: [
        [ .56, .56 ],
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.seat,
        TagFurnitureUse.relax,
      ]
    }
  },
  'vitra-nelson-bench-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/08c5d4f8-6076-4ca4-a50c-ee01e5027f56.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/663c2681-8a1d-4f1c-8205-2b01a506beb1.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Nelson Bench (long)',
      owner: 'Vitra',
      designer: 'George Nelson',
      priceBase: 117000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Weil am Rhein, CH',
      measurementOptions: [
        183.7, 46.9, 35.3
      ],
      materialNames: [
        'Slatted wood / Black ash base'
      ],
      sizeOptions: [
        [.35, 1.85]
      ],
      materialOptions: [
        'wood-glossy'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.sofa,
        TagFurnitureUse.seat,
        TagFurnitureUse.relax
      ]
    } 
  },
  'vitra-nelson-bench-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/2abb169f-a32b-41e4-84b3-92318f2fc653.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9d0f44a0-f26d-4a25-b158-f633ca0cec03.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Nelson Bench (short)',
      owner: 'Vitra',
      designer: 'George Nelson',
      priceBase: 61900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Weil am Rhein, CH',
      measurementOptions: [
        122, 46.9, 35.3
      ],
      materialNames: [
        'Slatted wood / Black ash base'
      ],
      sizeOptions: [
        [.35, 1.22]
      ],
      materialOptions: [
        'wood-glossy'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.sofa,
        TagFurnitureUse.seat,
        TagFurnitureUse.relax
      ]
    } 
  },
  'eames-fiberglass-armchair-daw': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c578f68f-b82e-4d2e-9820-d4db77c02625.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2bb669f-42d3-4939-84d8-5b71f8f1d33f.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Fiberglass Armchair DAW',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 87500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 60, 83, 62.5 ],
      ],
      materialNames: [
        'Elephant Hide Grey',
        'Parchment',
        'Row Umber',
        'Sea Foam Green'
      ],
      sizeOptions: [
        [ .6, .6 ],
      ],
      materialOptions: [
        'eames-dark-gray',
        'eames-parchment',
        'eames-light-gray',
        'eames-dark-green'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.connox.com/categories/furniture/seating-furniture/chairs/vitra-eames-fiberglass-armchair-daw.html'
    }
  },
  'eames-plastic-armchair-rar': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/0d8254db-b5bc-45a1-bb43-e591b2efc997.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2d7090aa-3145-46c6-84ae-90c9ab7c5b39.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Plastic Armchair RAR',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 53000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 81, 76, 63 ],
      ],
      materialNames: [
        'White',
        'Ice gray',
        'Light gray',
        'Granite gray',
        'Green',
        'Forest',
        'Sea blue',
        'Deep black',
        'Rusty orange',
        'Poppy red',
        'Pale rose',
        'Pebble',
        'Sunlight',
        'Mustard'
      ],
      sizeOptions: [
        [ .63, .81 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-ice-gray',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-green',
        'eames-dark-green',
        'eames-sea-blue',
        'eames-deep-black',
        'eames-rusty-orange',
        'eames-poppy-red',
        'eames-pale-rose',
        'eames-pebble',
        'eames-sunlight',
        'eames-mustard',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.smow.com/en/designers/charles-ray-eames/eames-plastic-armchair-rar.html'
    }
  },
  'chaise-tout-bois': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/63c2d828-3f8e-493c-9858-1f1f438cbb80.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/253ef586-1b4f-4f7f-8d26-d876456e15aa.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Chaise Tout Bois',
      owner: 'Vitra',
      designer: 'Jean Prouvé',
      priceBase: 62500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'London, UK',
      measurementOptions: [
        [ 46, 80.5, 49 ],
      ],
      materialNames: [
        'Dark oak',
        'Natural oak'
      ],
      sizeOptions: [
        [ .49, .46 ],
      ],
      materialOptions: [
        'eames-dark-oak',
        'eames-dark-gray',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.utilitydesign.co.uk/vitra-chaise-tout-bois'
    }
  },
  'eames-plastic-side-chair-dsw': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ce64f158-86bd-456f-802e-c47e829043b7.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c316251c-61ba-410c-b333-ebd79218d26e.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Plastic Side Chair DSW',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 39500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 46.5, 83, 55 ],
      ],
      materialNames: [
        'White',
        'Ice gray',
        'Light gray',
        'Granite gray',
        'Green',
        'Forest',
        'Sea blue',
        'Deep black',
        'Rusty orange',
        'Poppy red',
        'Pale rose',
        'Pebble',
        'Sunlight',
        'Mustard'
      ],
      sizeOptions: [
        [ .550, .465 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-ice-gray',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-green',
        'eames-dark-green',
        'eames-sea-blue',
        'eames-deep-black',
        'eames-rusty-orange',
        'eames-poppy-red',
        'eames-pale-rose',
        'eames-pebble',
        'eames-sunlight',
        'eames-mustard',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.smow.com/rooms/eames-plastic-side-chair-dsw.html'
    }
  },
  'eames-elephant': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e7c83032-d9c7-4177-a992-dbf71b2166a8.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/97ce8efb-aea9-4b0c-a6c8-22406d1f5e73.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Elephant',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 21900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 41, 41.5, 78.5 ],
      ],
      materialNames: [
        'White',
        'Ice gray',
        'Green',
        'Deep black',
        'Poppy red',
        'Pale rose',
        'Buttercup',
      ],
      sizeOptions: [
        [ .785, .410 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-ice-gray',
        'eames-green',
        'eames-deep-black',
        'eames-poppy-red',
        'eames-pale-rose',
        'eames-sunlight',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair,
        TagRoom.decor
      ],
      webshopUrl: 'https://www.smow.com/rooms/eames-elephant.html'
    }
  },
  'grand-repos-n-ottoman': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/f09196b4-3ada-454f-bcb3-e840b4bd2d3c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4d8aecc3-e517-435a-a1c0-11c53b6769f1.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Grand Repos & Ottoman',
      owner: 'Vitra',
      designer: 'Antonio Citterio',
      priceBase: 513000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 81, 110, 74 ],
      ],
      materialNames: [
        'Summer grass',
        'Fern',
        'Teal blue',
        'Iron gray',
        'Mid-gray',
        'Black',
        'Red',
        'Canola'
      ],
      sizeOptions: [
        [ .74, .81 ],
      ],
      materialOptions: [
        'eames-green',
        'eames-dark-green',
        'eames-sea-blue',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-deep-black',
        'eames-poppy-red',
        'eames-rusty-orange',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair,
        TagFurnitureUse.work
      ],
      webshopUrl: 'https://www.smow.com/vitra/vitra-home-stories-for-winter-2018-19/grand-repos-chair-grand-repos-ottoman-fabric-mello-pebble-grey-41-cm-basic-dark.html'
    }
  },
  'eames-storage-unit-esu': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e7ea44c9-ad52-4604-9cf2-9099e197427d.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bb38d173-c550-4478-a7fa-16cf2cffa693.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Storage Unit ESU',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 138000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 120, 148, 43 ],
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 43, 1.2 ],
      ],
      materialOptions: [
        'eames-multicolor'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureUse.storage,
        TagFurnitureType.shelf
      ],
      webshopUrl: 'https://designlinq.nl/nl/vitra-kast-eames-storage-unit-esu-shelf-1-door-charles-ray-eames/'
    }
  },
  'fauteuil-de-salon': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/d2092a86-8d38-46a1-a222-02197c79f953.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d97ed646-3207-44da-8670-cecc0e7439b6.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Fauteuil de Salon',
      owner: 'Vitra',
      designer: 'Jean Prouvé',
      priceBase: 235900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 68, 82.5, 84 ],
      ],
      materialNames: [
        'Pearl',
        'Light gray',
        'Ice blue',
        'Green',
        'Green gray',
        'Dark gray',
        'Black',
        'Canola',
        'Dark red',
        'Light red',
      ],
      sizeOptions: [
        [ .84, .68 ],
      ],
      materialOptions: [
        'eames-parchment',
        'eames-light-gray',
        'eames-ice-gray',
        'eames-green',
        'eames-dark-green',
        'eames-dark-gray',
        'eames-deep-black',
        'eames-rusty-orange',
        'eames-blood-red',
        'eames-poppy-red',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.flinders.nl/vitra-fauteuil-de-salon-fauteuil'
    }
  },
  'soft-pad-chairs-ea': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/0b289618-8d4a-461b-89cd-b86986f1bfd4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8f8947b9-d178-4cc7-aa77-7b298353ff61.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Soft Pad Chairs EA 219',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 360000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 52.5, 99.5, 59.5 ],
      ],
      materialNames: [
        'Snow white',
        'Dim gray',
        'Asphalt gray',
        'Sand',
        'Nero',
        'Marron',
        'Red',
      ],
      sizeOptions: [
        [ .595, .525 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-mustard',
        'eames-deep-black',
        'eames-rusty-orange',
        'eames-blood-red',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureUse.work,
        TagFurnitureType.chair,
      ],
      webshopUrl: 'https://www.smow.com/highlights/mid-century-modern/soft-pad-group-ea-219.html'
    }
  },
  'fauteuil-direction-pivotant': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/fad1f38a-bc09-4a93-8d96-4ed1f59a07e8.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2b09e9a9-26ff-4c00-842b-136da83d619e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Fauteuil Direction Pivotant',
      owner: 'Vitra',
      designer: 'Jean Prouvé',
      priceBase: 335000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 67, 83.5, 55 ],
      ],
      materialNames: [
        'Dark red',
        'Black',
        'Pearl'
      ],
      sizeOptions: [
        [ .55, .67 ],
      ],
      materialOptions: [
        'eames-blood-red',
        'eames-deep-black',
        'eames-light-gray',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureUse.work,
        TagFurnitureType.chair,
      ],
      webshopUrl: 'https://hivemodern.com/pages/product13096/fauteuil-direction-pivotant-jean-prouve-vitra'
    }
  },
  'em-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/95c1231a-4303-4d68-b16c-df1b343b75d9.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8dc112c8-18ec-4d46-8b72-87736c19ae51.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'EM Table',
      owner: 'Vitra',
      designer: 'Jean Prouvé',
      priceBase: 342000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 180, 74, 90 ],
      ],
      materialNames: [
        'Asphalt',
        'Ivory'
      ],
      sizeOptions: [
        [ .9, 1.8 ],
      ],
      materialOptions: [
        'eames-deep-black',
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.work,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.flinders.nl/vitra-em-table-tafel'
    }
  },
  'standard-sp': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/da9d4da9-dab8-4882-9da9-4375591a3dba.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3a237abe-b435-49a7-8fee-c7279f3ad2c8.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Standard SP',
      owner: 'Vitra',
      designer: 'Jean Prouvé',
      priceBase: 44000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 42, 82, 49 ],
      ],
      materialNames: [
        'Citron',
        'Olive',
        'Basalt',
        'Deep black',
        'Marron',
        'Warm gray',
      ],
      sizeOptions: [
        [ .49, .42 ],
      ],
      materialOptions: [
        'eames-sunlight',
        'eames-mustard',
        'eames-dark-gray',
        'eames-deep-black',
        'eames-blood-red',
        'eames-light-gray',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.work,
        TagFurnitureUse.seat,
        TagFurnitureType.chair,
      ],
      webshopUrl: 'https://www.smow.com/en/designers/jean-prouv/standard-sp.html'
    }
  },
  'eames-desk-unit-edu': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/877b8c6d-23dc-4425-9a48-ba1155e680c7.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/24ff145e-481e-4e67-b7b5-97704beb34a3.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Desk Unit EDU',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 129000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 152.5, 74, 71 ],
      ],
      materialNames: [
        'Birch',
      ],
      sizeOptions: [
        [ .71, 1.5 ]
      ],
      materialOptions: [
        'eames-multicolor'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.work,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.designcollectors.com/en/vitra/charles-ray-eames/home/1396-eames-desk-unit-edu'
    }
  },
  'grand-sofa-duo-seater': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/dfc67988-8d5f-4cef-8261-d1fa880a89a0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6a4fbba8-c577-452c-ac0f-45e42322e1d6.glb',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Grand Sofà 2½-Seater',
      owner: 'Vitra',
      designer: 'Antonio Citterio',
      priceBase: 471074,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 180, 90, 110 ],
      ],
      materialNames: [
        'Cream',
        'Pearl',
        'Cement',
        'Canary',
        'Cashew',
        'Green-gray',
        'Pebble gray',
      ],
      sizeOptions: [
        [ 1.1, 1.8 ]
      ],
      materialOptions: [
        'eames-white',
        'eames-mustard',
        'eames-light-gray',
        'eames-sunlight',
        'eames-rusty-orange',
        'eames-green',
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureUse.sleep,
        TagFurnitureType.sofa,
      ],
      webshopUrl: 'https://www.workbrands.com/en/vitra-vitra-grand-sofa-full-backrest-3-seater.html'
    }
  },
  'alcove-highback-sofa': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/91f8c17f-0edf-4f82-a050-60dd3bc8a8f1.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f25226b0-027c-4cb1-b3b5-ef945aa54238.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Alcove Highback Sofa',
      owner: 'Vitra',
      designer: 'Ronan & Erwan Bouroullec',
      priceBase: 836000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 238, 136, 86 ],
      ],
      materialNames: [
        'Ice blue',
        'Stone gray',
        'Pastel green',
        'Grass green',
        'Dark gray',
        'Black',
        'Dark red',
        'Red'
      ],
      sizeOptions: [
        [ .9, 2.4 ]
      ],
      materialOptions: [
        'eames-ice-gray',
        'eames-light-gray',
        'eames-sunlight',
        'eames-green',
        'eames-dark-gray',
        'eames-deep-black',
        'eames-blood-red',
        'eames-poppy-red',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureUse.sleep,
        TagFurnitureType.sofa,
      ],
      webshopUrl: 'https://www.ambientedirect.com/en/vitra/alcove-highback-3-seater-sofa_pid_514024.html'
    }
  },
  'lobby-chair-es': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/289741e3-671d-4de8-b057-1df1b9f50abf.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/32f6cfb9-3732-4417-99dc-d4ebe42997fb.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Lobby Chair ES',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 588000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 75, 78, 74.5 ],
      ],
      materialNames: [
        'Snow',
        'Cement',
        'Granite',
        'Smoke blue',
        'Nero',
        'Brandy',
        'Red stone',
        'Cognac',
      ],
      sizeOptions: [
        [ .75, .75 ]
      ],
      materialOptions: [
        'eames-white',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-ice-gray',
        'eames-deep-black',
        'eames-blood-red',
        'eames-poppy-red',
        'eames-rusty-orange',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureUse.work,
        TagFurnitureType.chair,
      ],
      webshopUrl: 'https://www.smow.com/en/designers/charles-ray-eames/lobby-chair-es-104.html'
    }
  },
  'home-desk': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/2ace8f3b-b300-48ae-91ff-85f5d314a5c2.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/2983ae65-4964-40a7-bfe4-e52ea7147b20.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Home Desk',
      owner: 'Vitra',
      designer: 'George Nelson',
      priceBase: 284298,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 99, 86.7, 72.3 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .723, .99 ]
      ],
      materialOptions: [
        'eames-multicolor-2'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.work,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.workbrands.com/en/vitra-vitra-home-desk.html'
    }
  },
  'eames-plastic-side-chair-dss': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/5d564abf-1a66-4222-8c4d-c7bb6576c921.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bc6bb185-c427-41f5-97af-4492931193fa.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Eames Plastic Side Chair DSS',
      owner: 'Vitra',
      designer: 'Charles & Ray Eames',
      priceBase: 23500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Germany, DE',
      measurementOptions: [
        [ 60, 81, 55 ],
      ],
      materialNames: [
        'White',
        'Ice gray',
        'Light gray',
        'Granite gray',
        'Green',
        'Forest',
        'Sea blue',
        'Deep black',
        'Rusty orange',
        'Poppy red',
        'Pale rose',
        'Pebble',
        'Sunlight',
        'Mustard'
      ],
      sizeOptions: [
        [ .55, .6 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-ice-gray',
        'eames-light-gray',
        'eames-dark-gray',
        'eames-green',
        'eames-dark-green',
        'eames-sea-blue',
        'eames-deep-black',
        'eames-rusty-orange',
        'eames-poppy-red',
        'eames-pale-rose',
        'eames-pebble',
        'eames-sunlight',
        'eames-mustard',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat,
        TagFurnitureType.chair
      ],
      webshopUrl: 'https://www.smow.com/en/designers/charles-ray-eames/eames-plastic-side-chair-dss-dss-n.html'
    }
  },
  'window-45in': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8bdfc447-8c73-46b3-95fe-5f8495648b75.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/52db089f-fa92-4ffc-b130-0ff92f1b4550.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Window 45in',
      owner: '',
      designer: '',
      priceBase: 0,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: '',
      measurementOptions: [
        [ 90, 70, 50 ],
      ],
      materialNames: [
        'Gray',
        'White',
        'Black',
        'Dark Oak',
      ],
      sizeOptions: [
        [ .70, .50, .90 ],
      ],
      materialOptions: [
        'wallpaper-matte-eggshell',
        'wallpaper-matte-white',
        'wallpaper-matte-black',
        'wallpaper-matte-brown'
      ],
      tags: [
        TagFurnitureType.window
      ],
    }
  },
  'window-95in': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9c197259-11e2-4f8a-9d84-08e63b02b0ca.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/cf4bc96e-23fb-497c-8eb7-04dfefdb711e.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Window 95in',
      owner: '',
      designer: '',
      priceBase: 0,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: '',
      measurementOptions: [
        [ 90, 220, 50 ],
      ],
      materialNames: [
        'Gray',
        'White',
        'Black',
        'Dark Oak',
        'Black & White',
        'Wood & White'
      ],
      sizeOptions: [
        [ .90, .50, 2.2 ],
      ],
      materialOptions: [
        'wallpaper-matte-eggshell',
        'wallpaper-matte-white',
        'wallpaper-matte-black',
        'wallpaper-matte-brown',
        'ikea-white-black',
        'eames-white'
      ],
      tags: [
        TagFurnitureType.window
      ],
    }
  },
  'cando-boardpaneel-calgary': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/add3836d-4eec-41a4-a548-e8ad2e428f12.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f4550cc4-669a-4eb3-8f22-78e04114d2dc.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Boardpaneel Calgary',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 10900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 83, 201.5, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'eames-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-binnendeur-boardpaneel-calgary-stomp-201-5x83cm/0231705'
    }
  },
  'cando-bradford-blank-glas': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/15572921-397b-4f86-9b58-a50ae2fe4482.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b8c6dbe8-0c37-4c7f-af18-ede8b08cd8a6.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Bradford blank glas 4-ruits',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 39900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 231.5, 50 ],
      ],
      materialNames: [
        'Black & White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-black-and-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-luxe-binnendeur-bradford-blank-glas-4-ruits-stomp-231-5-x-93cm/5679980'
    }
  },
  'cando-dimension-newcastle': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/7321b974-3de9-4968-aa61-1347b0463206.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bbbaa604-52f1-4f14-a8f0-d5b2179b0e33.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Dimension Newcastle',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 39900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 231.5, 50 ],
      ],
      materialNames: [
        'Black & White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'eames-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-binnendeur-dimension-newcastle-opdek-rechts-211-5-x-88cm/5186531'
    }
  },
  'cando-hyde-4-vaks-stomp': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e551af0e-a766-496e-ba5d-f3e3a68230f0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/22f78dff-4b4b-4889-b767-8acae0edae35.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Hyde 4-vaks stomp',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 34500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 83, 201.5, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'wallpaper-matte-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-luxe-binnendeur-hyde-4-vaks-stomp-201-5-x-83cm/5679986'
    }
  },
  'cando-dimension-bolton-blank-glas': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/66ad3585-3ee9-4dca-8c66-8addfb9e247b.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/09ddfe18-7046-436c-9a2c-a51b0fbe8cee.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Dimension Bolton',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 28500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 83, 211.5, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'wallpaper-matte-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-binnendeur-dimension-bolton-stomp-met-blank-glas-211-5x83cm/2501492'
    }
  },
  'cando-dimension-newcastle': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/34021d5a-8726-400b-ba56-2d794639e836.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8e797779-9e6f-444f-b838-13b30411431e.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Dimension Newcastle',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 29900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 88, 211.5, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'eames-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-binnendeur-dimension-newcastle-opdek-rechts-211-5-x-88cm/5186531'
    }
  },
  'cando-louvredeur': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/7625e465-9676-4c03-9bdd-9a31aa984ca8.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a6d516dd-9928-4974-b7c4-b54576352a92.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Louvredeur',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 5099,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 78.8, 198, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'eames-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/louvredeuren/cando-louvredeur-dicht-198-x-39-4cm/6023734'
    }
  },
  'cando-barn-silo': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/cbf15fc6-5801-4762-98a5-2c755019730e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d00e1dd5-b52b-4c81-aff6-93f7a80659ff.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Barn Silo',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 39900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 83, 231, 50 ],
      ],
      materialNames: [
        'White'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'eames-white'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/binnendeuren/cando-binnendeur-barn-silo-met-voorgemonteerde-roedes-stomp-231-x-83cm/5664718'
    }
  },
  'cando-achterdeur-ml-559': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/86480057-cd2f-470f-ad23-163421f89f03.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1c54decd-9732-4e1c-925a-893039fb47f1.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 559',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 33500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 211.5, 50 ],
      ],
      materialNames: [
        'Massief hardhout'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-achterdeur-green'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/achterdeuren/cando-achterdeur-ml-559-93-x-211-5cm/5353983'
    }
  },
  'cando-voordeur-ml-625': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/588d952f-6d2e-458b-8e7f-5e660dc67bab.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/15171096-a436-48ca-b7c6-143c1f610dbd.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 625',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 61900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 201.5, 50 ],
      ],
      materialNames: [
        'Massief merbau'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-light'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/achterdeuren/cando-achterdeur-ml-559-93-x-211-5cm/5353983'
    }
  },
  'cando-voordeur-ml-650': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/0fe60b19-5020-436c-b3d6-0eb559ed474e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f06283a8-ecfe-439c-abf5-3dc92d5f49d5.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 650',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 57900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 211.5, 50 ],
      ],
      materialNames: [
        'Grijs'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-dark'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/voordeuren/cando-voordeur-ml-650-211-5-x-93cm/5186477'
    }
  },
  'cando-voordeur-ml-670': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/86523a59-ef44-4023-8068-f00c17451087.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e6c37820-b9bc-4d75-a765-e084156f685e.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 670',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 88900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 211.5, 50 ],
      ],
      materialNames: [
        'Grijs'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-dark'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/voordeuren/cando-voordeur-ml-670-211-5-x-93cm/5187242'
    }
  },
  'cando-voordeur-ml-675': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a34a5dc0-775d-49f8-b3ed-4551e323dd5b.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/03df0279-ce30-4590-96e7-7c27f92e7332.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 675',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 98900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 231.5, 50 ],
      ],
      materialNames: [
        'Lightgrijs'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-dark'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/voordeuren/cando-voordeur-ml-675-231-5x93cm/5152169'
    }
  },
  'cando-voordeur-ml-660': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e7b8f4b5-af79-4eeb-ad1b-c713075c0c58.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/904e910b-dc37-4569-9bb8-b1b9ecbe89b3.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 660',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 57500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 211.5, 50 ],
      ],
      materialNames: [
        'Lightgrijs'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-dark'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/voordeuren/cando-voordeur-ml-660-211-5-x-93cm/4416864'
    }
  },
  'cando-voordeur-ml-616': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ffaa12d4-2160-4226-b564-783d252d2df0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/429e9156-7dae-4860-9ce9-5e302a3108f6.dae',
    snapToWall: true,
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ML 616',
      owner: 'CanDo',
      designer: 'CanDo',
      priceBase: 68500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 93, 201.5, 50 ],
      ],
      materialNames: [
        'Lightgrijs'
      ],
      sizeOptions: [
        [ .90, .50, 2.1 ],
      ],
      materialOptions: [
        'cando-voordeur-dark'
      ],
      tags: [
        TagFurnitureType.door
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/deuren/voordeuren/cando-voordeur-ml-616-201-5-x-93cm/5200559'
    }
  },
  'rechte-steektrap-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9cfdd47b-6470-40ed-9340-2706822d7dad.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/348f1473-ec77-4fe0-82d5-a7d0eff0e507.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Rechte Steektrap',
      owner: 'Houtentrappen',
      designer: 'Houtentrappen',
      priceBase: 31500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 215, 254, 70 ],
      ],
      materialNames: [
        'Beech',
        'Mahogany',
        'Steel',
      ],
      sizeOptions: [
        [ 2.15, .70, 2.54 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-dark-wood',
        'metal-rough',
      ],
      tags: [
        TagFurnitureType.stairs
      ],
      webshopUrl: 'https://www.houtentrappenwinkel.nl/c-3337141/rechte-steektrap/'
    }
  },
  'rechte-steektrap-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/cddc54fb-6a59-4dce-9c98-2534686dcc47.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ab470938-eb93-44b9-aecf-85d339533050.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Rechte Steektrap',
      owner: 'Houtentrappen',
      designer: 'Houtentrappen',
      priceBase: 37500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 215, 254, 70 ],
      ],
      materialNames: [
        'Beech',
        'Mahogany',
        'Stone'
      ],
      sizeOptions: [
        [ 2.15, .70, 2.54 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-dark-wood',
        'ground-concrete'
      ],
      tags: [
        TagFurnitureType.stairs
      ],
      webshopUrl: 'https://www.houtentrappenwinkel.nl/c-3337141/rechte-steektrap/'
    }
  },
  'rechte-steektrap-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/d8450079-f9fc-4262-b8a5-dd61dc627854.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bf191171-619e-48ed-83ee-9b35255f4438.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Rechte Steektrap',
      owner: 'Houtentrappen',
      designer: 'Houtentrappen',
      priceBase: 37500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 215, 254, 70 ],
      ],
      materialNames: [
        'Beech',
        'Mahogany',
        'Stone'
      ],
      sizeOptions: [
        [ 2.15, .70, 2.54 ],
      ],
      materialOptions: [
        'eames-white',
        'eames-dark-wood',
        'ground-concrete'
      ],
      tags: [
        TagFurnitureType.stairs
      ],
      webshopUrl: 'https://www.houtentrappenwinkel.nl/c-3337141/rechte-steektrap/'
    }
  },
  'round-stairs-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c3d5a2e7-6349-4364-a6dc-8bc2fefb0c78.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e7008226-2ada-4506-aaec-b2571b349313.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Staircase (Round)',
      owner: 'Bespoke',
      designer: '',
      priceBase: 0,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: '',
      measurementOptions: [
        [ 150, 254, 150 ],
      ],
      materialNames: [
        'Gray',
        'White',
        'Orange',
        'Red',
        'Blue',
        'Steel'
      ],
      sizeOptions: [
        [ 1.5, .70, 1.5 ],
      ],
      materialOptions: [
        'eames-ice-gray',
        'eames-white',
        'eames-rusty-orange',
        'wallpaper-halfmatte-red',
        'wallpaper-halfmatte-dark-blue',
        'metal-rough',
      ],
      tags: [
        TagFurnitureType.stairs
      ]
    }
  },
  'ikea-laett-childrens-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a48458b9-99a5-48f7-900a-7070cf911dae.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/d730d5f1-66f3-45c7-82a1-c9583c82789d.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LÄTT Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 63, 45, 48 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .63, .48 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/laett-childrens-table-with-2-chairs-white-pine-50178411/'
    }
  },
  'ikea-stuva-bench': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e7fcbdc3-784c-4097-b036-9abe5426ba36.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/90619989-66ad-4cca-8e65-351ae018dd6e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STUVA Bench',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 90, 50, 50 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .9, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureType.table,
        TagFurnitureUse.work
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/stuva-bench-white-30128629/'
    }
  },
  'ikea-mammut-chair': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/86b33e90-5b6f-4db3-8e28-a79236436582.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/600ccd23-67fe-447c-9a48-ffde88ec5c13.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MAMMUT Chair',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1295,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 39, 67, 37 ]
      ],
      materialNames: [
        'White',
        'Pink',
        'Red',
        'Blue',
      ],
      sizeOptions: [
        [ .39, .37 ]
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-pink',
        'wallpaper-matte-red',
        'wallpaper-matte-blue',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.relax,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/mammut-childrens-chair-in-outdoor-white-40365371/'
    }
  },
  'ikea-kritter-chair': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/37945ea9-ee65-4240-a212-ed70277a2bcb.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/186e0d36-a71a-4bc4-8800-58de7fe0fdf8.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KRITTER Chair',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1495,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 27, 53, 29 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .27, .29 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.relax,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kritter-childrens-chair-white-40153699/'
    }
  },
  'ikea-flisat-stool': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/b92e8dde-27a7-4f73-b585-c6c8e1dd6a98.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7e7a3564-b045-42e9-9213-50c61ce9595d.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'FLISAT Stool',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1495,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 24, 28, 24 ]
      ],
      materialNames: [
        'Pine',
      ],
      sizeOptions: [
        [ .24, .24 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/flisat-childrens-stool-40273593/'
    }
  },
  'ikea-mammut-stool': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8548e879-7378-43e0-a9d5-31d9c6919ebc.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/8c8840bf-4d22-47b6-ae09-66fbc44ad049.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MAMMUT Stool',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 599,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 30, 30, 30 ]
      ],
      materialNames: [
        'Yellow',
      ],
      sizeOptions: [
        [ .3, .3 ]
      ],
      materialOptions: [
        'wallpaper-matte-yellow',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/mammut-childrens-stool-in-outdoor-yellow-20382324/'
    }
  },
  'ikea-flisat-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/24493573-bee1-400e-a2cc-42ec2624fb87.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/da14aed3-68fe-43f9-ac7b-4bf05ea47fe4.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'FLISAT Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 4995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 83, 48, 58 ]
      ],
      materialNames: [
        'Pine',
      ],
      sizeOptions: [
        [ .83, .58 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/flisat-childrens-table-50298418/'
    }
  },
  'ikea-micke-desk': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/4fc2cc55-4c84-4177-8a64-114dbf327bd6.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a5930ebb-1ee4-4498-8840-0d8d82b11879.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MICKE Desk',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 73, 75, 50 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .73, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureType.table,
        TagFurnitureUse.work
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/micke-desk-white-30213076/'
    }
  },
  'ikea-pahl-desk': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9cad5f64-11cc-4057-be13-a362248bbf56.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c91ccd0f-4677-4945-8740-0908d58b2857.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'PAHL Desk',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 128, 72, 58 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.28, .58 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureType.table,
        TagFurnitureUse.work
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/pahl-desk-white-s89128953/'
    }
  },
  'ikea-mammut-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9f6129cd-2035-424d-af6f-35c6e5117ffd.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bdcba913-10e2-47d3-a3b4-4e7829032dda.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MAMMUT Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 85, 48, 85 ]
      ],
      materialNames: [
        'Blue',
      ],
      sizeOptions: [
        [ .85, .85 ]
      ],
      materialOptions: [
        'wallpaper-dark-blue'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/mammut-childrens-table-in-outdoor-blue-90365180/'
    }
  },
  'ikea-kallax-shelving-unit-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/2338aa44-73b2-4ea2-9630-a19dceb6b252.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ea8ae74b-4885-478c-b716-f55c791462d3.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KALLAX Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 9995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 147, 147, 39 ]
      ],
      materialNames: [
        'White',
        'Black',
        'Pine',
      ],
      sizeOptions: [
        [ 1.47, .39 ]
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kallax-shelving-unit-white-30275861/'
    }
  },
  'ikea-tornviken-kitchen-island': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/5e874002-769f-4df2-bb37-d364b7369882.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/866e84c8-f2e9-427e-9f18-bc25df49e565.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TORNVIKEN Kitchen Island',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 29900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 126, 90, 77 ]
      ],
      materialNames: [
        'White / Oak',
      ],
      sizeOptions: [
        [ 1.26, .77 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.kitchen,
        TagFurnitureType.table,
        TagFurnitureUse.eat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/tornviken-kitchen-island-off-white-oak-40391657/'
    }
  },
  'ikea-bror-work-bench': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/31a11aff-29f7-479e-8aac-d4684d2cb3bc.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ec341419-5617-4a67-84d0-20b67b3e5ac4.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BROR Workbench',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 12900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 110, 88, 55 ]
      ],
      materialNames: [
        'Black / Pine',
      ],
      sizeOptions: [
        [ 1.1, .55 ]
      ],
      materialOptions: [
        'eames-dark-gray',
      ],
      tags: [
        TagFurnitureType.table,
        TagFurnitureUse.work,
        TagFurnitureUse.storage,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/bror-work-bench-black-pine-plywood-30333286/'
    }
  },
  'ikea-norraker-bench': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8b0d1aa9-f0f1-4e99-96c8-27619c10c4e8.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1c130204-7708-4302-b584-22d1516138f5.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'NORRAKER Bench',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 103, 45, 29 ]
      ],
      materialNames: [
        'Birch',
      ],
      sizeOptions: [
        [ 1.03, .29 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/norraker-bench-birch-60428990/'
    }
  },
  'ikea-norraker-stool': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/2e74254e-3746-4c52-9d11-fb87e72f3de6.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b8fca087-c9f0-47a7-bc57-22b302bc8384.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'NORRAKER Stool',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 45, 45, 29 ]
      ],
      materialNames: [
        'Birch',
      ],
      sizeOptions: [
        [ .45, .29 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.chair,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/norraker-stool-birch-00428974/'
    }
  },
  'ikea-norraker-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a8086ccd-a4e9-47d2-8dd1-a03d1b8ce67d.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1857da83-e4a0-4882-8d53-cadf7f86de2f.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'NORRAKER Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 14900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 125, 74, 74 ]
      ],
      materialNames: [
        'Birch',
      ],
      sizeOptions: [
        [ 1.25, .74 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/norraker-table-birch-30428982/'
    }
  },
  'ikea-stensele-bar-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/92893d55-7b0e-4233-bece-514d63d7d54c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/96cd110b-51ad-4b6c-abf2-012c698540d4.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'STENSELE Bar Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 11900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 70, 105, 70 ]
      ],
      materialNames: [
        'Anthracite',
      ],
      sizeOptions: [
        [ .7, .7 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/stensele-bar-table-anthracite-anthracite-s09288224/'
    }
  },
  'ikea-toresund-bar-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/cf82483d-e2bd-4bbc-947e-83acaf6e12c0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4963c19-bb2e-407a-af00-f980eccdaaa6.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TORESUND Bar Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 14900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 140, 91, 70 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.4, .7 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/toresund-bar-table-white-high-gloss-80301532/'
    }
  },
  'ikea-tommaryd-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c45d831e-c790-4228-b478-9311a3c4d6fe.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/052abebd-81ba-4fb0-8267-41eb6540819d.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TOMMARYD Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 16900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 130, 105, 70 ]
      ],
      materialNames: [
        'Light Gray',
      ],
      sizeOptions: [
        [ 1.3, .7 ]
      ],
      materialOptions: [
        'wallpaper-matte-gray'
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.kitchen,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/tommaryd-table-light-grey-s29304807/'
    }
  },
  'ikea-toredo-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/89ba2c0b-5955-44b3-9660-1c7bd34b3db6.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/017d7236-0f21-405e-8c33-ad6a19c38d6a.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TÄREDÕ Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 110, 74, 67 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1.1, .67 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/taerendoe-table-black-s99000483/'
    }
  },
  'ikea-lack-side-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9c45dcb6-5e94-46d0-893b-72c31d921b16.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0ef592f3-fbee-433d-a392-ee40a8bdc80d.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LACK Side Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 599,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 55, 45, 55]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .5, .5 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.table,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/lack-side-table-black-20011408/'
    }
  },
  'ikea-lisabo-desk': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/b6b3fe2c-0307-472b-94bb-44f315587884.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/25894a78-7567-4f1c-9f85-d3907b1cb9c7.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LISABO Desk',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 17900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 105, 74, 105 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1, 1 ]
      ],
      materialOptions: [
        'eames-dark-oak',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/lisabo-table-black-50416501/'
    }
  },
  'ikea-vittsjoe-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/4a289bc0-c05b-49fc-88f8-9a72f8c6ac19.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3c413302-fd91-4a4e-82c3-c48637c2ebb3.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'VITTSJÕ Tables',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 90, 50, 50 ]
      ],
      materialNames: [
        'Black / Glass',
      ],
      sizeOptions: [
        [ .9, .5 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.table,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/vittsjoe-nest-of-tables-set-of-2-black-brown-glass-80215332/'
    }
  },
  'ikea-lack-console-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e72abec7-2521-4b12-9f44-3eaf5a8f83f4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7968a734-2b77-4716-bd5c-e9e8a5b58e72.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LACK Console Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 4995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 140, 65, 39 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.4, .39 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/lack-console-table-white-high-gloss-10257448/'
    }
  },
  'ikea-malm-bed-frame': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/50c7b012-b57f-48da-94a2-9a3594981ba4.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/98c2b8b7-0e58-4cc1-a444-b77212283882.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MALM Bed',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 27900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 156, 38, 209 ]
      ],
      materialNames: [
        'Black-brown',
      ],
      sizeOptions: [
        [ 1.5, 2 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.bed,
        TagFurnitureUse.sleep
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/malm-bed-frame-high-black-brown-leirsund-s19019839/'
    }
  },
  'ikea-slattum-upholstered-bed': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/2c6d6bec-c014-436b-8098-ee80a3352537.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9c5419c6-c9f3-47be-9f40-4dd2da53c889.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'SLATTUM Bed',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 9995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 144, 40, 206 ]
      ],
      materialNames: [
        'Knisa Gray',
      ],
      sizeOptions: [
        [ 1.4, 2]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.bed,
        TagFurnitureUse.sleep
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/slattum-upholstered-bed-frame-knisa-light-grey-30446373/'
    }
  },
  'ikea-neiden-bed': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/041c01f3-1db0-4007-a307-58d6e21155a5.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c71fd28b-c11e-4d38-a343-b8727e628802.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'NEIDEN Bed',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 144, 30, 205 ]
      ],
      materialNames: [
        'Pine',
      ],
      sizeOptions: [
        [ 1.4, 2 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.bed,
        TagFurnitureUse.sleep
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/neiden-bed-frame-pine-70395239/'
    }
  },
  'ikea-askvoll-bed': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a23fae09-3103-4a3c-907c-6f2cabc56754.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3c8462ed-7a4f-4a56-8a20-f6a34f2c62b8.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ASKVOLL Bed',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 7995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 97, 43, 208 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1, 2 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.bed,
        TagFurnitureUse.sleep
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/askvoll-bed-frame-white-90387115/'
    }
  },
  'ikea-kallax-shelving-unit-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/dd544060-4e4e-4061-832f-8e4cb4fbb29e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/12d7b0a4-baab-4600-94fc-b7702737e1d7.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KALLAX Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 77, 147, 39 ]
      ],
      materialNames: [
        'Oak',
      ],
      sizeOptions: [
        [ .77, .39 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kallax-shelving-unit-white-stained-oak-effect-00324518/'
    }
  },
  'ikea-besta-storage-combination': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8b429df0-7b3d-4f7d-b9f0-abd86573f323.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/85be892e-fd02-40ea-ad92-e18c486cf0f1.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BESTA Wardrobe',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 29000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 120, 192, 40 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.2, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/besta-storage-combination-with-doors-lappviken-white-s79057526/'
    }
  },
  'ikea-larsfrid-sideboard-unit': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/41b4937c-6362-4948-b125-17289b4804d9.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/52a5d81d-f3b9-4520-aec4-636d8ae397a2.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LARSFRID',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 32000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 151, 90, 52 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.51, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/larsfrid-sideboard-basic-unit-white-60342185/'
    }
  },
  'ikea-kullen-chest-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9d95894f-189a-4d08-8a11-7eb597927b46.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/07272642-d547-409a-9b27-0e79b0e18cbe.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KULLEN Chest (3 Drawers)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 70, 72, 40 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .7, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kullen-chest-of-3-drawers-white-60309237/'
    }
  },
  'ikea-askvoll-chest-3-drawers': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ca62854d-8b35-4229-a89c-5bf79c0ba64c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/f38ae625-7445-4f31-b36d-db0c41e8fe24.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'ASKVOLL Chest (3 Drawers)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 70, 68, 41 ]
      ],
      materialNames: [
        'White / Oak',
      ],
      sizeOptions: [
        [ .7, .4 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/askvoll-chest-of-3-drawers-white-stained-oak-effect-white-20270802/'
    }
  },
  'ikea-besta-tv-bench': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/cf5244e3-a78c-44b8-96b1-75c3e4afe13d.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e23f31cb-8de7-41f0-a721-f9aad92a15bf.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BESTA TV Bench',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 12900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 120, 39, 42 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.2, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/besta-tv-bench-with-drawers-white-selsviken-high-gloss-dark-red-brown-s19324373/'
    }
  },
  'ikea-kallax-shelving-unit-4': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ba3f13cb-b575-40fd-b5b4-265d82f674d3.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c5490afa-8310-4cd2-9c9e-fc1497355a6e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KALLAX Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 7495,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 112, 147, 39 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1.1, .4 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kallax-shelving-unit-black-brown-20409936/'
    }
  },
  'ikea-fjaellbo-shelving-unit': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9b38c86c-9dce-4714-8392-dc7af550a1f0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/6d36d1eb-cae9-4422-a1fd-012f3cc7441c.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'FJÄLLBO Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 9995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 100, 136, 36 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1, .4 ]
      ],
      materialOptions: [
        'eames-dark-gray',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/fjaellbo-shelving-unit-black-70339291/'
    }
  },
  'ikea-bror-shelving-unit': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ff76cccd-2f88-42e7-9d80-05f02f9bda25.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b1551a7f-0bb7-48a2-a949-b30cd6229664.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BROR Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 28500,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 254, 190, 40 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 2.5, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/bror-shelving-unit-white-s49303958/'
    }
  },
  'ikea-kallax-shelving-unit-5': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/57ff0697-bd5a-44da-98ea-6c38afa75ab2.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/12d7b0a4-baab-4600-94fc-b7702737e1d7.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KALLAX Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 77, 147, 39 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .7, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kallax-shelving-unit-white-80275887/'
    }
  },
  'ikea-brusali-bookcase': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/736257cd-7db9-4f40-809b-11abd5286fdc.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/e70150ad-c6d1-4655-ac61-5facc188910e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BRUSALI Bookcase',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 7995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 67, 190, 33 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .7, .3 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/brusali-bookcase-white-60439743/'
    }
  },
  'ikea-billy-bookcase': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/f2c35d3a-7a46-4854-871d-b6bd9b770c6a.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bde77979-b039-4fcd-825d-88533499b481.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BILLY Bookcase',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 80, 202, 39 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .8, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/billy-bookcase-white-90401932/'
    }
  },
  'ikea-vittsjo-shelving-unit': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/4aed7725-886d-4c27-b4ae-c709b1ba8bf9.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/536c1364-7afd-4b44-9968-fbff40abb662.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'VITTSJO Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 7995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 100, 175, 36 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1, .4 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/vittsjoe-shelving-unit-black-brown-glass-20213312/'
    }
  },
  'ikea-lack-wall-shelf': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c0cd56c2-9e29-4a04-b536-9376770cc8c0.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1810356e-9b43-4106-9cb1-f3325a2dfa28.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'LACK Wall Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 4995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 30, 190, 28 ]
      ],
      materialNames: [
        'Oak',
      ],
      sizeOptions: [
        [ .3, .3 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/lack-wall-shelf-unit-white-stained-oak-effect-60430592/'
    }
  },
  'ikea-kallax-shelving-unit-6': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/6e3609fe-0320-4603-9af2-6727fe8ba97c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/9829ea21-9f82-487e-b3e8-c7d9176731b0.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KALLAX Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 42, 147, 39 ]
      ],
      materialNames: [
        'Oak',
      ],
      sizeOptions: [
        [ .4, .4 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kallax-shelving-unit-white-stained-oak-effect-40324516/'
    }
  },
  'ikea-kleppstad-wardrobe-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c6d301b9-d0f3-4a0b-bddd-ce851d05257c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b19b23bf-82e0-4222-ad69-986c603b6b20.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KLEPPSTAD Wardrobe (3 Door)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 7995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 117, 176, 55 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.2, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kleppstad-wardrobe-with-3-doors-white-00441758/'
    }
  },
  'ikea-kleppstad-wardrobe-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/042c8df4-1116-4b46-aca0-91a5ffa9781b.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/870b0144-49f6-40a3-bf3f-ffecad63facd.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KLEPPSTAD Wardrobe (2 Door)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 5995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 80, 176, 55 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .8, .6 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kleppstad-wardrobe-with-2-doors-white-80437234/'
    }
  },
  'ikea-brimnes-wardrobe-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/d98ce384-4f7f-46f9-95e6-9b5d463f8d1b.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b50560af-c4e8-4f46-92b1-81a2ec56ef66.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'BRIMNES Wardrobe (3 Door)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 14900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 117, 190, 50 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.2, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/brimnes-wardrobe-with-3-doors-white-40407922/'
    }
  },
  'ikea-rigga-clothes-rack': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/bb5737d5-7c1e-4989-8071-4b96e9e40646.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3ee0692f-1ade-4198-a459-f863729d3b77.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'RIGGA Clothes Rack',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1495,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 111, 175, 51 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.1, .5 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureUse.storage,
        TagFurnitureUse.hanger,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/rigga-clothes-rack-white-50231630/'
    }
  },
  'ikea-mackapaer-shoe-organiser': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/fed053f2-923b-4821-bee7-96d4ead8764e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7cae167e-17a9-4803-a8ec-d865039402cd.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MACKAPÄR Shoe Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 6995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 45, 192, 30 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .5, .3 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/mackapaer-shoe-organiser-white-90334749/'
    }
  },
  'ikea-sandshult-wall-shelf': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/cbf3f107-b165-4764-9a14-802dace33c94.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/956a07d5-c2be-475c-b71c-6a41d1b20172.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'SANDSHULT Wall Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2000,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 80, 5, 20 ]
      ],
      materialNames: [
        'Aspen',
      ],
      sizeOptions: [
        [ .8, .2 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.kitchen,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/tranhult-sandshult-wall-shelf-aspen-s69326096/'
    }
  },
  'ikea-fjaellbo-wall-shelf': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e32a99ca-8266-47c9-bc45-46fe84432f7a.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4ee8b3cd-518b-492c-ad2a-071ebd2d3dcf.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'FJÄLLBO Wall Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2495,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 101, 5, 20 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1, .2 ]
      ],
      materialOptions: [
        'eames-dark-gray',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.kitchen,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/fjaellbo-wall-shelf-black-80421247/'
    }
  },
  'ikea-skogsta-wall-shelf': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/3255b64a-dac9-4864-bc92-3a71d36a2466.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/4466a12a-7b63-44e1-ab7c-3e56196dd8fc.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'SKOGSTA Wall Shelf',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 120, 5, 25 ]
      ],
      materialNames: [
        'Acacia',
      ],
      sizeOptions: [
        [ 1.2, .3 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.kitchen,
        TagFurnitureType.shelf,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/skogsta-wall-shelf-acacia-10300499/'
    }
  },
  'ikea-kubbis-clothes-rack': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ae635eaf-8519-4a09-8885-d39566594e90.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/7276903a-9b7e-4421-882c-b87ef556cb59.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KUBBIS Clothes Rack',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1295,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 105, 9, 10 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1, .1 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagFurnitureUse.storage,
        TagFurnitureUse.hanger,
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kubbis-rack-with-7-hooks-white-10289576/'
    }
  },
  'ikea-kullen-chest-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/62aaa0d8-9417-41ac-9d99-3a9f824eb8ba.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/29bc0c5c-0992-4190-9c43-555c6ce703d8.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KULLEN Chest (2 Drawers)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 1995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 35, 49, 40 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .4, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kullen-chest-of-2-drawers-white-80309241/'
    }
  },
  'ikea-trysil-bedside-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9af2b55b-5988-4149-a4ca-a9f0a94a48b1.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/74c2f4b1-9282-4520-a579-f541459acc23.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'TRYSIL Bedside Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 2995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 45, 53, 45 ]
      ],
      materialNames: [
        'White / Light Gray',
      ],
      sizeOptions: [
        [ .45, .45 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureType.table,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/trysil-bedside-table-white-light-grey-30236025/'
    }
  },
  'ikea-malm-chest-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/80477f9f-af3a-4d80-9e53-eb29f585cdbe.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/29bc0c5c-0992-4190-9c43-555c6ce703d8.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'MALM Chest (2 Drawers)',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 3995,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 40, 55, 48 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .4, .5 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureType.table,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/malm-chest-of-2-drawers-black-brown-00103343/'
    }
  },
  'ikea-knarrevik-bedside-table': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/1a733505-ac78-43ee-88c1-ac1b911b464e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/dbf9b513-e507-49e0-affc-04c51d32af78.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KNARREVIK Bedside Table',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 37, 45, 28 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .4, .3 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.bedRoom,
        TagFurnitureType.cupboard,
        TagFurnitureType.table,
        TagFurnitureUse.storage
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/knarrevik-bedside-table-black-30381183/'
    }
  },
  'ikea-friheten-sofa': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/f92f5d4e-fd8b-4eae-be90-2dbbf87527ab.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/56120d3f-bf78-4277-b519-f4d1d652c88d.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'FRIHETEN Sofa',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 39900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 225, 83, 105 ]
      ],
      materialNames: [
        'Skiftebo blue',
      ],
      sizeOptions: [
        [ 2.25, 1.05 ]
      ],
      materialOptions: [
        'wallpaper-matte-dark-blue'
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.sofa,
        TagFurnitureUse.relax,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/friheten-3-seat-sofa-bed-skiftebo-blue-60431563/'
    }
  },
  'ikea-kivik-sofa': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9ee93710-c481-45f0-9cc4-e0b9e1aecb58.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5c7355ed-77b8-4897-98dd-ca4d89a96552.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'KIVIK Sofa',
      owner: 'IKEA',
      designer: 'IKEA',
      priceBase: 48900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 225, 83, 105 ]
      ],
      materialNames: [
        'Skiftebo Dark Gray',
      ],
      sizeOptions: [
        [ 2.25, 1.05 ]
      ],
      materialOptions: [
        'wallpaper-matte-black',
      ],
      tags: [
        TagRoom.livingRoom,
        TagFurnitureType.sofa,
        TagFurnitureUse.relax,
        TagFurnitureUse.seat
      ],
      webshopUrl: 'https://www.ikea.com/nl/en/p/kivik-3-seat-sofa-skiftebo-dark-grey-s29305581/'
    }
  },
  'grohe-douche-system-vitalio-joy': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/93179cb2-8c65-4f5b-bfc8-3c6fc1054595.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/0ae17827-d20c-49bf-b7c6-f5d6b7154e71.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Douchesystem Vitalio Joy',
      owner: 'GROHE',
      designer: '',
      priceBase: 49900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 11, 100, 11 ]
      ],
      materialNames: [
        'Chrome',
      ],
      sizeOptions: [
        [ 1, 1 ]
      ],
      materialOptions: [
        'metal',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.bathWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/badkamer/douche/douchesets/grohe-douchesysteem-vitalio-joy-met-thermostaatkraan-260mm-chroom/5653495'
    }
  },
  'aquavive-pedaalemmer': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9737f52d-15a5-4240-b023-b1fd25ab6ead.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/257dd4a9-d5b9-47cd-81c7-1d674ff0fa78.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Trashbin',
      owner: 'Aquavive',
      designer: '',
      priceBase: 999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 16, 26, 16 ]
      ],
      materialNames: [
        'Lichtgrijs',
      ],
      sizeOptions: [
        [ .5, .5 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.toiletWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/schoonmaken/prullenbakken/prullenbakken/aquavive-pedaalemmer-lichtgrijs-3l/5345685'
    }
  },
  'curver-afvalbak-decobin': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/3ca3a376-f0f4-4a09-bb65-8d5c84ccd1f2.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4e10f57-4385-4a82-93a2-529a6eb4f7d1.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Trashbin',
      owner: 'Curver',
      designer: '',
      priceBase: 5499,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 39, 73, 29 ]
      ],
      materialNames: [
        'Black / Chrome',
      ],
      sizeOptions: [
        [ .5, .3 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.toiletWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/schoonmaken/prullenbakken-vuilniszakken/prullenbakken/curver-afvalbak-decobin-zilver-metallic-50l/5276088'
    }
  },
  'aquavive-wandcloset-compact': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ba981c98-df14-4ee5-9717-a584ff37d897.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/db91b12c-ca71-4f6d-a157-d2d036f88146.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Arve',
      owner: 'Aquavive',
      designer: '',
      priceBase: 12900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 36, 50, 36 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .4, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.toiletWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/toilet/wandclosetten/aquavive-wandcloset-compact-arve/5453223'
    }
  },
  'aquavive-fonteinset-somme': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9a25670d-fba9-4379-94e5-14debe162b69.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3188a704-aace-4427-b2f5-09e08b181633.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Somme',
      owner: 'Aquavive',
      designer: '',
      priceBase: 11900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 37, 9, 18 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .4, .2 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.washWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/toilet/toiletfonteinen/aquavive-fonteinset-somme-keramiek-wit-37-5cm/5448410'
    }
  },
  'allibert-duoblok': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/b4dc958f-85fe-4de0-bb24-356fe15b917e.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/1c25fe62-4174-4561-a3dd-87c30ec6edd3.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Duoblok',
      owner: 'Allibert',
      designer: '',
      priceBase: 27900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 37, 80, 61 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .4, .6 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.toiletWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/toilet/duoblok-toiletten/allibert-duoblok-kobalt-wit/10012186'
    }
  },
  'differnz-fonteinset-gaia': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/fd7632d9-fb29-432a-a06d-10b2f96beb32.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/17f695ff-d976-4283-a3b5-887825305053.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Gaia',
      owner: 'Differenz',
      designer: '',
      priceBase: 4999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 32, 28, 15 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .3, .3 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.washWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/toilet/toiletfonteinen/differnz-fonteinset-gaia-keramiek-15cm/5468139'
    }
  },
  'differnz-wastafelset-minos': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/473d1502-f9b9-4014-aa15-7dbe427e2154.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/dd9ed4b1-5d19-425f-a95e-f1fca67cc468.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Minos',
      owner: 'Differnz',
      designer: '',
      priceBase: 17900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 46, 15, 15 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .4, .4 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureType.washWare,
        TagFurnitureUse.wash
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/toilet/toiletfonteinen/differnz-wastafelset-minos-keramiek-15-5cm/5468223'
    }
  },
  'eglo-hanglamp-blackcrown': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/9e9d08a3-c67b-4076-9f35-f421b0e5079c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a338ecfc-32c9-49d1-b3f3-6c39980ee29e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Blackcrown',
      owner: 'EGLO',
      designer: '',
      priceBase: 11400,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 100, 20, 20 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ 1, .2 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.light,
      ],
      webshopUrl: 'https://www.praxis.nl/verf-laminaat-decoratie/verlichting/hanglampen/eglo-hanglamp-blackcrown-5xe27/10016774'
    }
  },
  'eglo-vintage-hanglamp-truro': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/f123f8dc-de0e-4f1e-8a77-aa401208e334.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bc96a3e7-1228-425c-bbac-2aaeba1883ff.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Truro Vintage',
      owner: 'EGLO',
      designer: '',
      priceBase: 3499,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 21, 21, 21 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .21, .21 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.light,
      ],
      webshopUrl: 'https://www.praxis.nl/verf-laminaat-decoratie/verlichting/hanglampen/eglo-vintage-hanglamp-truro-21cm-zwart-koper/5410731'
    }
  },
  'lucide-wandlamp-leanne': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/b62a6619-2f8d-4663-9279-6eb7af59b240.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/51b66c69-f3e1-48bd-a344-36e0965d0443.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Leanne',
      owner: 'Lucide',
      designer: '',
      priceBase: 1699,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 14.5, 10, 12 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .25, .25 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.light,
      ],
      webshopUrl: 'https://www.praxis.nl/verf-laminaat-decoratie/verlichting/wandlampen/lucide-wandlamp-leanne-zwart/10014097'
    }
  },
  'baseline-torenventilator': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/4ec32293-8227-4942-9d6b-93eba2adf24c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a445a212-a0ea-479c-8762-ae0d4b1866c1.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Torenventilator',
      owner: 'Baseline',
      designer: '',
      priceBase: 4499,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 17.5, 80, 19.5 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .2, .2 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.livingRoom,
        TagRoom.bedRoom,
        TagFurnitureUse.temparature
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/luchtbehandeling/ventilatoren/baseline-torenventilator-fz10-20m-35w/10020975'
    }
  },
  'plieger-paneelradiator-compact': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/75a49238-5c25-42a8-b49c-af5a8df0a6ff.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/de3b2bbe-d5da-40c3-aff7-a4120c809415.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Wall Radiator',
      owner: 'Plieger',
      designer: '',
      priceBase: 199,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 160, 40, 10 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ 1.6, .2 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureUse.temparature
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/verwarming/centrale-verwarming-vaste-installatie/paneelradiatoren/plieger-paneelradiator-compact-22-wit-40-x-160-x-10-5cm/2509495'
    }
  },
  'design-radiator': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/85946488-cd1c-47ea-a186-e9286a289142.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/44451f50-4643-4eda-a2fd-2fdeccf11924.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Radiator',
      owner: 'Design',
      designer: '',
      priceBase: 6499,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 60, 116, 10 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .6, .2 ]
      ],
      materialOptions: [
        'ikea-white-white',
      ],
      tags: [
        TagRoom.bathRoom,
        TagFurnitureUse.temparature
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/verwarming/centrale-verwarming-vaste-installatie/designradiatoren/design-radiator-60-x-116-cm-recht-model/5521689'
    }
  },
  'electrum-schouwafzuigkap': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/e1023fcb-0514-4758-a509-6e5af8496d08.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/a9377f0a-849c-4148-9019-8a73510442ad.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Kitchen Filter',
      owner: 'Electrum',
      designer: '',
      priceBase: 18900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 90, 78, 15 ]
      ],
      materialNames: [
        'Chrome',
      ],
      sizeOptions: [
        [ .9, .2 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.kitchen,
        TagFurnitureType.cookingWare,
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/keuken/afzuigkappen/electrum-schouwafzuigkap-tsh912lx-rvs-90cm/10012954'
    }
  },
  'electrum-onderbouw-afzuigkap': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/0223498f-cbec-491c-b75e-1da86d828da6.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/ceabade1-280b-4442-afc2-1611d4ba786e.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Kitchen Filter',
      owner: 'Electrum',
      designer: '',
      priceBase: 6999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 60, 15, 50.5 ]
      ],
      materialNames: [
        'White',
      ],
      sizeOptions: [
        [ .6, .5 ]
      ],
      materialOptions: [
        'ikea-white-black',
      ],
      tags: [
        TagRoom.kitchen,
        TagFurnitureType.cookingWare,
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/keuken/afzuigkappen/electrum-onderbouw-afzuigkap-uh611lw-wit-60cm/10008421'
    }
  },
  'electrum-inbouwkoelkast': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/25717dd2-f2d1-4afa-b0b8-0d3f9abac97a.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c9533d1e-f929-4394-96de-7356e8c9504f.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'HIC54X177A Fridge',
      owner: 'Electrum',
      designer: '',
      priceBase: 0,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 54, 177, 54 ]
      ],
      materialNames: [
        'White',
        'Dark Gray',
      ],
      sizeOptions: [
        [ .6, .6 ]
      ],
      materialOptions: [
        'ikea-white-white',
        'ikea-white-black',
      ],
      tags: [
        TagRoom.kitchen,
        TagFurnitureType.cookingWare,
        TagFurnitureUse.eat
      ],
      webshopUrl: 'https://www.praxis.nl/badkamer-keuken-wonen/keuken/koelkasten-vriezers/electrum-inbouwkoelkast-hic54x177a-wit-177cm/10009706'
    }
  },
  'bespoke-kitchen-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/99d4d404-4412-46ac-bf23-7bb0b533dc65.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/3ee1c53c-a31f-4baf-a2b6-aa1f6fea569a.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Bespoke',
      owner: '',
      designer: '',
      priceBase: 29900,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: '',
      measurementOptions: [
        [ 126, 90, 77 ]
      ],
      materialNames: [
        'White / Oak',
      ],
      sizeOptions: [
        [ 1.26, .77 ]
      ],
      materialOptions: [
        'eames-pebble',
      ],
      tags: [
        TagRoom.kitchen,
        TagFurnitureType.table,
        TagFurnitureUse.eat
      ],
    }
  },
  'picture-frame-1': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/a8149559-680e-4991-a5bf-11f5513a862f.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/c1a9759c-2035-4051-a537-6b2d1ec1b1e7.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    contextType: 'painting',
    details: {
      name: 'Frame 20x30',
      owner: 'Fotolijsten',
      designer: '',
      priceBase: 1954,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 20, 30, 5 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .2, .2 ]
      ],
      materialOptions: [
        'ikea-white-black'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.fotolijsten.nl/zwart-hout-nerf-1060-224'
    }
  },
  'picture-frame-2': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/ac7135d4-1ae2-417e-b936-1fc49285910f.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/66b4eace-27ed-4e96-b750-c059ef881465.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    contextType: 'painting',
    details: {
      name: 'Frame 70x50',
      owner: 'Fotolijsten',
      designer: '',
      priceBase: 1545,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 70, 50, 5 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .7, .2 ]
      ],
      materialOptions: [
        'ikea-white-black'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.fotolijsten.nl/fotolijsten/foto-50x70'
    }
  },
  'picture-frame-3': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/c249f899-88b8-47b9-90f8-5c6c6c9ec20c.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/28433053-c33f-4720-993c-a6e45c01f766.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    contextType: 'painting',
    details: {
      name: 'Frames (Mixed)',
      owner: 'Fotolijsten',
      designer: '',
      priceBase: 1445,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 30, 30, 5 ]
      ],
      materialNames: [
        'Black',
      ],
      sizeOptions: [
        [ .3, .2 ]
      ],
      materialOptions: [
        'ikea-white-black'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.fotolijsten.nl/fotolijsten'
    }
  },
  'plant-pot-flower': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/8338522e-9a1d-4cb6-b49a-509a0fd550d3.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/149d99e6-2194-4f25-8b5c-d5a1014e3119.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Brussels',
      owner: 'Elho',
      designer: '',
      priceBase: 1849,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 29, 27, 29 ]
      ],
      materialNames: [
        'Anthracite',
      ],
      sizeOptions: [
        [ .3, .3 ]
      ],
      materialOptions: [
        'plant'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ],
      webshopUrl: 'https://www.praxis.nl/verf-laminaat-decoratie/woondecoratie/potten-vazen/elho-pot-brussels-rond-antraciet-30cm/3733624'
    }
  },
  'plant-decor-hedge': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/78a6fa7b-a544-4483-a509-cb2e964548b2.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/5e815701-64f4-45d9-8576-eac342779ab2.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Hedge (Decor)',
      owner: '',
      designer: '',
      priceBase: 9999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 100, 100, 50 ]
      ],
      materialNames: [
        'Green',
      ],
      sizeOptions: [
        [ 1, .5 ]
      ],
      materialOptions: [
        'plant'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ]
    }
  },
  'plant-decor-tree': {
    previewUrl: '//cdn.wtlstudio.com/common-ptr.wtlstudio.com/70a10b1e-2553-48b1-8177-ac97e5d78947.png',
    modelUrl: 'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/bf36e583-bb32-46c9-ba36-178321607c0b.dae',
    modelScale: 4.0,
    materialId: 0,
    sizeId: 0,
    details: {
      name: 'Tree (Decor)',
      owner: '',
      designer: '',
      priceBase: 25999,
      priceCurrency: 'eur',
      taxRate: 0,
      shippingFrom: 'Amsterdam, NL',
      measurementOptions: [
        [ 100, 300, 100 ]
      ],
      materialNames: [
        'Green',
      ],
      sizeOptions: [
        [ 1, 1 ]
      ],
      materialOptions: [
        'plant'
      ],
      tags: [
        TagRoom.decor,
        TagFurnitureType.plants,
        TagFurnitureUse.relax
      ]
    }
  },
};
